import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { HeaderStats } from '@aytm/app/stats/page/question-views/bpm/components/mds/Controls'

// What the perceptual map says about itself: its legend and the fit of the projection.
const MdsHeader = ({ answer, colorGradients, mdsBrandsValue }) => (
  <HeaderStats answer={answer} colorGradients={colorGradients} mdsBrandsValue={mdsBrandsValue} />
)

MdsHeader.displayName = 'BpmMdsHeader'

MdsHeader.propTypes = {
  answer: answerPropType,
  colorGradients: PropTypes.object,
  mdsBrandsValue: PropTypes.array
}

export default MdsHeader
